import { useMemo } from 'react'

export function useUniqueOptions<T extends { value: unknown }>(
    options?: Array<T>
): Array<T> | undefined {
    return useMemo(() => {
        if (!options) return undefined

        const seen = new Set<unknown>()

        return options.filter((option) => {
            if (seen.has(option.value)) return false
            seen.add(option.value)
            return true
        })
    }, [options])
}
